import api from './api';
export const ShopifyService = {
    searchProducts(query, limit = 10) {
        return api.get('/api/shopify/products', { params: { query, limit } });
    },
    searchOrders(email, limit = 10) {
        return api.get('/api/shopify/orders', { params: { email, limit } });
    },
};
